module.exports = __webpack_public_path__ + "static/media/400410_02.45f06b9e.png";